(ns rothko.theme.sandi.header
  (:refer-clojure :exclude [rem])
  (:require [garden.units :refer [rem]]
            [rothko.theme.sandi.colours :refer [colours]]))

(def header-height (rem 6))

(def main
  {:primary
   {:background-color (:blue-dark colours)}})
